'use client';
import React from 'react';
import StoreProvider from '@/redux/storeProvider';
import { ThemeProviderProps } from 'next-themes/dist/types';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';

import '../styles/globals.css';
import RouteLoader from '@/components/loading/RouteLoader';
import LocaleProvider from './LocaleProvider';
import CookieConsentBanner from '@/components/consent/CookieConsentBanner';
import GoogleAnalytics from '@/components/consent/GoogleAnalytics';
import CookieConsentSync from '@/components/consent/CookieConsentSync';

export interface ProvidersProps {
  children: React.ReactNode;
  themeProps?: ThemeProviderProps;
}

export function Providers({ children, themeProps }: ProvidersProps) {
  return (
    <StoreProvider>
      <LocaleProvider themeProps={themeProps}>
        <RouteLoader>{children}</RouteLoader>
        <CookieConsentBanner />
        <GoogleAnalytics />
        <CookieConsentSync />
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar
          closeOnClick
          pauseOnHover
          draggable
          pauseOnFocusLoss
          style={{ zIndex: 9999999 }}
        />
      </LocaleProvider>
    </StoreProvider>
  );
}
